import { useTranslate } from "@similarweb/i18n-provider";
import { ListContentLoader } from "@similarweb/ui-components";

import { StateContainer } from "./StateContainer";

export const LoadingState = () => {
    const { translate } = useTranslate();

    return (
        <StateContainer
            title={translate("platform.alerts.loading.title")}
            subtitle={translate("platform.alerts.loading.subtitle")}
            data-automation="alerts-loading-state"
        >
            <ListContentLoader />
        </StateContainer>
    );
};
